import { useState, type FormEvent } from "react";
import { siteMeta } from "@/mocks/articles";

const FORM_URL = "https://readdy.ai/api/form/dagnr3ptto0ceqqni1a0";

interface Status {
  type: "idle" | "success" | "error";
  msg: string;
}

export default function NewsletterForm() {
  const [status, setStatus] = useState<Status>({ type: "idle", msg: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    // 反垃圾：蜜罐被填充则静默当成功处理，不发送
    if ((fd.get("mobile_alt") as string)?.trim()) {
      setStatus({ type: "success", msg: "订阅成功，感谢你的关注！" });
      form.reset();
      return;
    }
    fd.delete("mobile_alt");

    const email = (fd.get("email") as string) || "";
    if (!email) {
      setStatus({ type: "error", msg: "请填写有效的邮箱地址。" });
      return;
    }

    setLoading(true);
    setStatus({ type: "idle", msg: "" });
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(fd as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: any = null;
      try {
        parsed = text ? JSON.parse(text) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || text;
      const ok = res.ok && parsed?.code === "OK";
      if (ok) {
        setStatus({ type: "success", msg: serverMsg || "订阅成功，欢迎加入读者俱乐部！" });
        form.reset();
      } else {
        setStatus({ type: "error", msg: serverMsg || "提交失败，请稍后再试。" });
      }
    } catch {
      setStatus({ type: "error", msg: "网络异常，请稍后再试。" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-readdy-form="home-newsletter" onSubmit={onSubmit} noValidate>
      {/* 反垃圾蜜罐 */}
      <div className="frm-catch" aria-hidden="true">
        <label htmlFor="newsletter-mobile">联系电话</label>
        <input
          type="text"
          id="newsletter-mobile"
          name="mobile_alt"
          tabIndex={-1}
          autoComplete="off"
          readOnly
        />
      </div>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <input
          type="email"
          name="email"
          required
          placeholder="输入你的邮箱地址"
          aria-label="邮箱地址"
          className="h-12 flex-1 rounded-md border border-foreground-900/20 bg-background-50 px-4 text-sm outline-none transition-colors focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
        />
        <button
          type="submit"
          disabled={loading}
          className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {loading ? (
            <i className="ri-loader-4-line animate-spin"></i>
          ) : (
            <i className="ri-mail-send-line"></i>
          )}
          {loading ? "提交中…" : "订阅每日盘点"}
        </button>
      </div>
      <p className="mt-3 text-xs text-foreground-500">
        每周精选 3 封人物盘点，绝无打扰，可随时退订。发送至 {siteMeta.email} 与我们联系。
      </p>
      {status.type !== "idle" && (
        <p
          className={`mt-3 rounded-md px-3 py-2 text-sm ${
            status.type === "success"
              ? "bg-primary-100 text-primary-900"
              : "bg-accent-100 text-accent-900"
          }`}
        >
          {status.msg}
        </p>
      )}
    </form>
  );
}